import type { AcceptInviteInput, ImpersonationExited, LoginInput, MeResponse, RegisterInput } from '@brechoflow/contracts';
import { http } from '@/lib/api';

export interface InvitationPreview {
  email: string;
  organizationName: string;
  roleName: string;
  expiresAt: string;
  /** Verdadeiro quando o e-mail já tem conta: basta informar a senha atual. */
  userExists: boolean;
}

export const authApi = {
  me: () => http.get<MeResponse>('/auth/me'),
  login: (input: LoginInput) => http.post<{ ok: true }>('/auth/login', input),
  register: (input: Omit<RegisterInput, 'timezone'> & { timezone?: string }) => http.post<{ ok: true }>('/auth/register', input),
  logout: () => http.post<{ ok: true }>('/auth/logout'),
  forgotPassword: (email: string) => http.post<{ ok: true; message: string }>('/auth/forgot-password', { email }),
  resetPassword: (token: string, password: string) => http.post<{ ok: true }>('/auth/reset-password', { token, password }),
  previewInvite: (token: string) => http.post<InvitationPreview>('/auth/invitations/preview', { token }),
  acceptInvite: (input: AcceptInviteInput) => http.post<{ ok: true }>('/auth/invitations/accept', input),
  /** Sai do acesso de suporte e restaura a sessão do operador. */
  exitImpersonation: () => http.post<ImpersonationExited>('/platform/impersonate/exit'),
  /** Aceita a versão vigente dos Termos/Política (a versão precisa bater com a do servidor). */
  acceptTerms: (version: string) => http.post<MeResponse>('/auth/accept-terms', { version }),
  switchOrganization: (organizationId: string) => http.post<MeResponse>('/auth/switch-organization', { organizationId }),
};
